import { Injectable, inject } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';
import { Platform } from '@angular/cdk/platform';

@Injectable({
  providedIn: 'root'
})
export class ServiceworkService {
  swUpdate = inject(SwUpdate);

  public data: { mobileType: 'ios' | 'android'; promptEvent?: any; } | undefined;
  private platform: Platform | undefined;
  public promptEvent: any;
  public close() {
    //this.bottomSheetRef.dismiss();
  }
  registerServiceWorker():string {
    let swMessage = '瀏覽器不支援PWA';
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/ngsw-worker.js')
      .then(function(registration) {
        // Registration was successful
        swMessage = 'ServiceWorker 已註册成功,scope: ', registration.scope;
      }, function(err) {
        swMessage = 'ServiceWorker 註册失敗: '+err.message;
        alert(swMessage);
      });
    }
    return swMessage;
    /*
    if (navigator.serviceWorker) {
      this.swMessage = '瀏覽器支援PWA'
      navigator.serviceWorker.register('./ngsw-worker.js') // service-worker
        .then(reg => this.regMessage = 'Service worker 已註册成功')
        .catch(err => this.regMessage = 'Service worker 註册失敗');
    } else {
      this.swMessage = '瀏覽器不支援PWA'
      //alert('不支持Service Worker');
    }*/

  }
  updateApp() {
    alert('開始測試是否可更新  TODO:.available 有問題 ');
    /*this.swUpdate.available.subscribe(event => {
    //this.swUpdate.subscribe(event => {
      alert('可更新')
      {
        this.swUpdate.activateUpdate().then(() => {
          alert('開始更新 location.reload')
          document.location.reload()
        });
      }

    })*/
    this.swUpdate.activateUpdate().then(() => {
      alert('開始更新 location.reload')
      document.location.reload()
    });

  }
  public installPwa(): void {
    if (this.data && this.data.promptEvent) {
      this.data.promptEvent.prompt();
    }
    this.close();
  }
  async initPwaPrompt() {
    if (this.platform && this.platform.ANDROID) {
      window.addEventListener('beforeinstallprompt', async (event: any) => {
        event.preventDefault();
        this.promptEvent = event;
        // this.openPromptComponent('android');
        let messageHtml = '<i>是否安裝</i>'
        let result: boolean = await confirm(messageHtml) // , '安裝到主畫面'
        if (result === true) {
          this.installPwa()
        }
      });
    }
    if (this.platform && this.platform.IOS) {
      const isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator['standalone']);
      if (!isInStandaloneMode) {
        //this.openPromptComponent('ios');
        let messageHtml = '<i>是否安裝</i>'
        let result: boolean = await confirm(messageHtml) // , '安裝到主畫面'
        if (result === true) {
          this.installPwa()
        }
      }
    }

    window.addEventListener('appinstalled', (evt) => {
      // Log install to analytics
      console.log('INSTALL: Success');
    });
  }
}
